import { render, staticRenderFns } from "./BaseForm.vue?vue&type=template&id=0371a433&scoped=true"
import script from "./BaseForm.vue?vue&type=script&lang=js"
export * from "./BaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0371a433",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0371a433')) {
      api.createRecord('0371a433', component.options)
    } else {
      api.reload('0371a433', component.options)
    }
    module.hot.accept("./BaseForm.vue?vue&type=template&id=0371a433&scoped=true", function () {
      api.rerender('0371a433', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/investments/model-list-manager/BaseForm.vue"
export default component.exports